(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PremDiscDetailController', PremDiscDetailController);

    PremDiscDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PremDisc', 'PremDiscGroup'];

    function PremDiscDetailController($scope, $rootScope, $stateParams, previousState, entity, PremDisc, PremDiscGroup) {
        var vm = this;

        vm.premDisc = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:premDiscUpdate', function(event, result) {
            vm.premDisc = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
